export default __webpack_public_path__ + "static/media/banner_1_ipad_pro.a60bda9b.png";